module.exports = __webpack_public_path__ + "img/p4.54bbd2c8.png";